import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface CourseLanguageDialogProps {
  open: boolean;
  availableLanguages: string[];
  onSelectLanguage: (lang: string) => void;
}

const CourseLanguageDialog: React.FC<CourseLanguageDialogProps> = ({
  open,
  availableLanguages,
  onSelectLanguage
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>{t('courseLanguageDialog.title')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('courseLanguageDialog.message')}
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {availableLanguages.map((lang) => (
            <Button key={lang} variant="outlined" onClick={() => onSelectLanguage(lang)}>
              {lang.toUpperCase()}
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default CourseLanguageDialog;
